import { MediaItemData } from "@/core/MediaItem/MediaItem.model";
import { createPortalClient } from "@/services/portalClient";
import { logger } from "@/utils/logger";

class EditorService {
  // Get editor media items using portal client
  async getMediaItems(
    clientId: string,
    mediaType: 'images' | 'videos',
    limit: number = 50,
    offset: number = 0,
  ): Promise<{ success: boolean; mediaItems?: MediaItemData[]; error?: string }> {
    try {
      const portalClient = createPortalClient(clientId, 'editor');

      logger.info("🔍 getMediaItems called:", {
        clientId,
        mediaType,
        isAuthenticated: portalClient.isAuthenticated(),
      });

      const data = await portalClient.get<{ success: boolean; mediaItems: MediaItemData[] }>(
        `/editor/${clientId}/media?media_type=${mediaType}&limit=${limit}&offset=${offset}`
      );

      return data;
    } catch (error) {
      logger.error("Failed to fetch media items:", error);
      return {
        success: false,
        error: error instanceof Error ? error.message : `Failed to load ${mediaType}`,
      };
    }
  }

}

export const editorService = new EditorService();
